import React from "react";
import { useSpring, animated } from '@react-spring/web';
import Cookies from 'js-cookie';

import PopupModal from "/components/PopupModal";

export default function Menu({ 
    isMenuActive, 
    data, 
    setCameraCoords, 
    setCameraHeight, 
    setIsMenuActive,
    setStationVisible,
    setVideoSrc,
    popupContent, 
    setPopupContent,
    resetAppState,
    setIsHomePlaceholderVisible
}) {
        
    const springs = useSpring({
        transform: isMenuActive ? `translateY(0%)` : `translateY(-100%)`,
    });

    const handleMenuItemClick = async (station) => {
        setCameraCoords(station.camera_coords);
        setCameraHeight(station.camera_height);
        setIsMenuActive(false);
        setStationVisible(station.index);
        await logStationView(station.index);
    };

    const handleOnboardingVideoClick = () => {
        setVideoSrc("https://pfizer-vwt.s3-accelerate.amazonaws.com/assets/intro-video.mp4");
        setIsMenuActive(false);
    };

    const handleHomeClick = () => {
        setIsMenuActive(false);
        resetAppState();
    }

    const handleDownloadAll = () => {
        const downloadUrl = `https://pfizer-vwt.s3-accelerate.amazonaws.com/assets/downloads.zip`;
        window.open(downloadUrl, '_blank');
    };

    const logStationView = async (stationIndex) => {
        const email = Cookies.get('userEmail');
        const stationName = data.stations[stationIndex].title;
        const apiUrl = `https://vwt-api.pfizer-qr.com/api/?e=${encodeURIComponent(email)}&c=website&a=click&l=${encodeURIComponent(stationName)}&v=nav`;
        try {
            const response = await fetch(apiUrl);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            console.log('Station view logged successfully');
        } catch (error) {
            console.error('Error logging station view:', error);
        }
    };

    return (
        <>
            <animated.div style={springs} className="menu-container">
                <div className="main-menu">
                    <div className="menuItem" onClick={handleHomeClick}>
                        <h1 className="diatype-light">Home</h1>
                    </div>
                    {data.stations && data.stations.map((station) => ( 
                        <div className="menuItem" key={station._id} onClick={() => handleMenuItemClick(station)}>
                            <h1 className="diatype-light">{station.title}</h1>
                        </div>
                    ))}
                    <div className="menuItem" style={{display: 'flex'}} onClick={() => handleDownloadAll()} >
                        <h1 className="diatype-light" style={{marginRight: '1rem', marginBottom: '0rem', fontStyle: 'italic'}}>Download All Files</h1>
                        <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M30.625 21.875V27.7083C30.625 28.4819 30.3177 29.2237 29.7707 29.7707C29.2237 30.3177 28.4819 30.625 27.7083 30.625H7.29167C6.51812 30.625 5.77625 30.3177 5.22927 29.7707C4.68229 29.2237 4.375 28.4819 4.375 27.7083V21.875" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M10.2085 14.5833L17.5002 21.8749L24.7918 14.5833" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M17.5 21.875V4.375" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </div>
                <div className="sub-menu">
                    <div className="smallMenuItem" onClick={handleOnboardingVideoClick}>
                        <h3 className="diatype-medium" style={{cursor: 'pointer'}}>Onboarding Video</h3>
                    </div>
                    <div className="smallMenuItem">
                        <h3 
                            className="diatype-medium" 
                            style={{cursor: 'pointer'}}
                            onClick={() => setPopupContent('termsandconditions')}
                        >Terms & Conditions</h3>
                    </div>
                    <div className="smallMenuItem">
                        <h3 
                            className="diatype-medium" 
                            style={{cursor: 'pointer'}}
                            onClick={() => setPopupContent('privacypolicy')}
                        >Privacy Policy</h3>
                    </div>
                    <div className="smallMenuItem">
                        <h3 
                            className="diatype-medium" 
                            style={{cursor: 'pointer'}}
                            onClick={() => setPopupContent('cookies')}
                        >Cookies</h3>
                    </div>
                </div>
                <p className="menu-footer-text">All rights reserved Pfizer 2024 - Website designed and developed by <a href="https://www.ignitiondg.com/" target="_blank" rel="noopener noreferrer" style={{color: 'white', textDecoration: 'none'}}>Ignition DG</a></p>
                {popupContent && (
                    <PopupModal popupContent={popupContent} setPopupContent={setPopupContent} data={data} />
                )}
            </animated.div>
        </>
    );
}